import {
  Currencies,
  DEPOSIT_ADDRESS_STATE,
  DepositAddressInformation,
  DEPOSIT_ADDRESS_TYPE,
} from "@letsbit/malcolmlb";

import { useContext } from "react";
import { SWRResponse } from "swr";

import { ApiContext } from "providers/ApiProvider";
import { useAuthSWR } from "hooks/utils/useAuthSWR";

export const SWR_MEMBER_WALLET_ADDRESS_KEY = "get-member-wallet-address";

export const useGetMemberDepositAddress = (
  currencyId?: Currencies,
  payment_network?: string,
  memberUid?: string,
): SWRResponse<DepositAddressInformation | undefined, { message: string }> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthSWR(
    currencyId && payment_network && memberUid
      ? [SWR_MEMBER_WALLET_ADDRESS_KEY, currencyId, payment_network, memberUid]
      : null,
    async () => {
      if (!currencyId || !payment_network || !memberUid) {
        return;
      }
      const { data } = await memberInstance.partner.getMemberDepositAddress({
        currency_id: currencyId,
        payment_network_id: payment_network,
        member_uid: memberUid,
      });
      if (
        data?.type !== DEPOSIT_ADDRESS_TYPE.OMNIBUS_ACCOUNT &&
        data?.data.state === DEPOSIT_ADDRESS_STATE.PENDING
      )
        throw new Error("Generando dirección");
      return data;
    },
    {
      revalidateIfStale: false,
      errorRetryInterval: 2000,
    },
  );
  return swr;
};
